import { SeoTrackingEvent } from 'nexchange-service/module/seo'

enum PaymentTrackingEventName {
    PURCHASE = 'PaymentWindow.Purchase',
}

type TOrderDetailsDto = {
    orderId: string
    purchaseAmount: number
    currency: string
    pair: {
        pairId: string // EUR-BTC
        label: string
    }
}

interface PaymentTrackingEvent extends SeoTrackingEvent {
    eventName: PaymentTrackingEventName
    orderDetails: TOrderDetailsDto
}

type PaymentWindowEventProps = {
    // eventName: PaymentTrackingEventName
    orderId: string
    quoteCode: string
    baseCode: string
    pairName: string
    quoteAmount: number
}

class GenericPaymentWindowEvent implements PaymentTrackingEvent {
    eventName: PaymentTrackingEventName
    orderDetails: TOrderDetailsDto

    constructor({ orderId, pairName, quoteCode, baseCode, quoteAmount }: PaymentWindowEventProps) {
        this.orderDetails = {
            orderId,
            currency: quoteCode,
            purchaseAmount: quoteAmount,
            pair: {
                pairId: pairName,
                label: `${quoteAmount} ${quoteCode} to ${baseCode}`,
            },
        }
    }
}

class PurchasePaymentWindowEvent extends GenericPaymentWindowEvent {
    eventName = PaymentTrackingEventName.PURCHASE
}

export type { PaymentWindowEventProps }
export { PurchasePaymentWindowEvent }
